import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {
    SET_FILES(state, files) {
      if (state.data?.order) {
        state.data.order.files = Array.isArray(files) ? files : [];
      }
    }
  },
  actions: {
    async fetchOrder({ commit, state, dispatch }, payload) {

      const requestId = (state.lastRequestId || 0) + 1;
      state.lastRequestId = requestId;

      try {
        commit('SET_LOADING', true);
        const id = typeof payload === 'object' ? payload.id : payload;
        const params = typeof payload === 'object' ? {
          page: payload.page,
          page_size: payload.pageSize,
          sort: payload.sort,
          sort_dir: payload.sortDir,
          ...(payload.filters || {}),
        } : {};
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/order/'+id+'/', { params });
        if (state.lastRequestId !== requestId) {
          return;
        }
        commit('SET_DATA', {data:response.data.data});
        // Синхронизируем positions в модуль positions
        if (response.data.data.positions) {
          dispatch('positions/syncPositionsFromOrder', response.data.data, { root: true });
        }
        commit('SET_ERROR', null);
      } catch (error) {
        if (state.lastRequestId !== requestId) {
          return;
        }
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        if (state.lastRequestId === requestId) {
          commit('SET_LOADING', false);
        }
      }
    },
    setFile({ commit, state }, files) {
      commit('SET_FILES', files);
    }
  },
  getters: {
    order: state => state.data?.order || {},
    positions: state => state.data?.positions || [],
    positionsPagination: state => state.data?.positions_pagination || null,
    positionsSort: state => state.data?.positions_sort || null,
    filterOptions: state => state.data?.filter_options || {},
    orderLoading: state => state.loading,
    orderError: state => state.error,
    orderLoaded: state => state.loaded,
  }
})
